var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loader',{attrs:{"id":"global-loader","variant":_vm.variant,"msg":_vm.globalLoadingMsg}})}
var staticRenderFns = []

export { render, staticRenderFns }